// extracted by mini-css-extract-plugin
module.exports = {"product":"product_product__1_-HO","discount":"product_discount__WCKB3","stars":"product_stars__2Jm9Q","buyBtn":"product_buyBtn__3FC6f"};